import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { usePaneLayout } from "context/PaneLayoutContext";
var PaneLayout = function (_a) {
    var sidebarLeft = _a.sidebarLeft, main = _a.main, sidebarRight = _a.sidebarRight, _b = _a.topOffsetPx, topOffsetPx = _b === void 0 ? 0 : _b, _c = _a.gap, gap = _c === void 0 ? 1 : _c;
    var _d = usePaneLayout(), showLeft = _d.showLeft, showRight = _d.showRight;
    var theme = useTheme();
    var isLg = useMediaQuery(theme.breakpoints.up("lg"));
    var hasLeftSidebar = Boolean(sidebarLeft);
    var hasRightSidebar = Boolean(sidebarRight);
    var makeAreas = function () {
        var parts = [];
        if (isLg && showLeft && hasLeftSidebar)
            parts.push("sidebar");
        parts.push("main");
        if (isLg && showRight && hasRightSidebar)
            parts.push("right");
        return "\"".concat(parts.join(" "), "\"");
    };
    var makeCols = function () {
        var cols = [];
        if (isLg && showLeft && hasLeftSidebar)
            cols.push("280px");
        cols.push("minmax(0, 13fr)");
        if (isLg && showRight && hasRightSidebar)
            cols.push("minmax(0, 6fr)");
        return cols.join(" ");
    };
    return (_jsxs(Box, { sx: {
            display: "grid",
            width: "100%",
            alignItems: "start",
            gap: gap,
            gridTemplateAreas: {
                xs: "\"main\"",
                lg: makeAreas(),
            },
            gridTemplateColumns: {
                xs: "1fr",
                lg: makeCols(),
            },
            minHeight: "calc(100vh - ".concat(topOffsetPx, "px)"),
        }, children: [isLg && showLeft && hasLeftSidebar && (_jsx(Box, { sx: {
                    gridArea: "sidebar",
                    minWidth: 0,
                    alignSelf: "start",
                    position: "sticky",
                    top: "var(--collections-items-sticky-top, var(--collections-secondary-sticky-top, 56px))",
                    zIndex: 10,
                }, children: sidebarLeft })), _jsx(Box, { sx: { gridArea: "main", minWidth: 0, alignSelf: "start" }, children: main }), isLg && showRight && hasRightSidebar && (_jsx(Box, { sx: {
                    gridArea: "right",
                    minWidth: 0,
                    alignSelf: "start",
                    position: "sticky",
                    top: "var(--collections-items-sticky-top, var(--collections-secondary-sticky-top, 56px))",
                    zIndex: 10,
                }, children: sidebarRight }))] }));
};
export default PaneLayout;
